import React, { useEffect, useState } from "react";
import { Input, Select, Button, Typography, Radio, Form } from "antd";
import LeadDetail from "../../../../components/Forms/EditableField";
import RenderFormItem from "../../../../components/Forms/FormItems";
import { FormColumnConfig, MasterConfigs } from "../../../../interfaces/entity";
import EditableField from "../../../../components/Forms/EditableField";
import EditableFormBlock from "../../../../components/Forms/EditableField";
import SmallProfileCard from "../../../../components/ContactInfo/SmallProfileCard";
import { constants } from "../../../../constants/common";
import moment from "moment";
import dayjs from "dayjs";
const { Option } = Select;
const { Text, Title } = Typography;

const CandidateOverview: React.FC<any> = ({ candidate }) => {
    const [form] = Form.useForm();
    const [editingField, setEditingField] = useState<any>(null);

    useEffect(() => {
        console.log(candidate);
    }, [candidate]);

    const leadsConfig: MasterConfigs = {
        api: () => '/users',
        getFormColumns: () => {
            return [
                {
                    span: 24,
                    render: (data) => <Title level={5} className="mb-2">Lead information</Title>,
                },
                {
                    label: 'First Name',
                    name: 'firstName',
                    type: 'text',
                    rules: [{
                        required: true,
                        message: 'First Name is required'
                    }]
                },
                {
                    label: 'Middel Name',
                    name: 'middelName',
                    type: 'text',
                    isRequired: false,
                },
                {
                    label: 'Last Name',
                    name: 'lastName',
                    type: 'text',
                    rules: [{
                        required: true,
                        message: 'Last Name is required'
                    }]
                },
                {
                    label: 'Gender',
                    name: 'gender',
                    rules: [{
                        required: true,
                        message: 'Gender is required'
                    }],
                    type: 'select',
                    children: [
                        { name: 'Male', value: 'Male' },
                        { name: 'Female', value: 'Female' },
                        { name: 'Other', value: 'Other' },
                    ],
                },
                {
                    label: 'Date Of Birth',
                    name: 'dob',
                    rules: [{
                        required: true,
                        message: 'Date Of Birth is required'
                    }],
                    type: 'date',
                    render: (text) => {
                        console.log('DOB:', text);
                        return dayjs(text).format('DD MMM YYYY');
                    },
                },
                {
                    span: 8
                },
                {
                    label: 'Work Email',
                    name: 'workEmail',
                    type: 'text',
                    rules: [{
                        required: true,
                        message: 'Work Email is required'
                    }, {
                        type: 'email',
                        message: 'Invalid email address'
                    }],
                },
                {
                    label: 'Email',
                    name: 'email',
                    type: 'text',
                    rules: [{
                        required: true,
                        message: 'Email is required'
                    }, {
                        type: 'email',
                        message: 'Invalid email address'
                    }],
                },
                {
                    span: 8
                },
                {
                    label: 'Mobile',
                    name: 'mobile',
                    type: 'number',
                    rules: [{
                        required: true,
                        message: 'Mobile is required'
                    }, {
                        pattern: /^[0-9]{10}$/,
                        message: "Mobile number must be 10 digits long!",
                    }],
                },
                {
                    label: 'Work Type',
                    name: 'workType',
                    type: 'select',
                    rules: [{
                        required: true,
                        message: 'Work Type is required'
                    }],
                    isCombo: true,
                },
                {
                    span: 8,
                },
                {
                    label: 'Number Serise',
                    name: 'numberSeries',
                    type: 'select',
                    rules: [{
                        required: true,
                        message: 'Number Serise is required'
                    }],
                    isCombo: true,
                },
            ];
        },
        combo: [
            {
                api: '/employee-number',
                name: 'numberSeries',
                idKey: '_id',
                render: (data) => data.name,
            },
            {
                api: '/worker-type',
                name: 'workType',
                idKey: '_id',
                render: (data) => data.name,
            },
            {
                name: 'role',
                api: '/role',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'department',
                api: '/departments',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'reportingManager',
                api: '/users/?includingme=yes',
                idKey: '_id',
                render: (e) => [e.firstName, e.middelName, e.lastName].join(' ')
            },
            {
                name: 'reportingHR',
                api: '/users/?includingme=yes',
                idKey: '_id',
                render: (e) => [e.firstName, e.middelName, e.lastName].join(' ')
            },
            {
                name: 'reportingBDE',
                api: '/users/?includingme=yes',
                idKey: '_id',
                render: (e) => [e.firstName, e.middelName, e.lastName].join(' ')
            },
            {
                name: 'timeType',
                api: '/time-type',
                idKey: '_id',
                render: (e) => e.name
            }, {
                name: 'legalEntity',
                api: '/legal-entity',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'businessUnit',
                api: '/business-unit',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'location',
                api: '/locations',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'probationPolicy',
                api: '/probation-policies',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'noticePeriod',
                api: '/notice-period',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                name: 'leavePlans',
                api: '/leave-plan',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'shiftType',
                api: '/shift-time',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'weeklyOff',
                api: '/weekly-offs',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'attendanceNumber',
                api: '/attendance-number',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'holidayList',
                api: '/holiday-list',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'attandanceCaptureScheme',
                api: '/attendance-capture-scheme',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'attandanceTrackingPolicy',
                api: '/attendance-tracking-policy',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'overtimePolicy',
                api: '/overtime',
                idKey: '_id',
                render: (data) => data.name,
            }, {
                name: 'expensePolicy',
                api: '/expences-policy',
                idKey: '_id',
                render: (data) => data.name,
            },
            {
                name: 'payGroup',
                api: '/pay-group',
                idKey: '_id',
                render: (ele) => ele.name,
            },
            {
                name: 'salaryStructureType',
                api: '/salary-structure-type',
                idKey: '_id',
                render: (ele) => ele.name,
            },
            {
                name: 'customSalaryStructure',
                api: '/custom-salary-structure-type',
                idKey: '_id',
                render: (ele) => ele.name,
            },
            {
                name: 'taxRegime',
                api: '/tax-regime',
                idKey: '_id',
                render: (ele) => ele.name,
            },
            {
                name: 'jobTitles',
                api: '/job-titles',
                idKey: '_id',
                render: (e) => e.name
            },
        ],
        getData: () => ({}),
        actions: [
            { name: 'Add User', actionType: 'Add' },
            { name: 'Return', actionType: 'Back' },
        ],
    };

    return (
        <div className="min-h-screen">
            {/* Header Section */}
            <div className="flex items-center gap-4 p-4 bg-white shadow-md rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-500 text-white text-xl rounded-full">
                    {candidate?.firstName?.charAt(0)}{candidate?.lastName?.charAt(0)}
                </div>
                <div>
                    <h2 className="text-lg font-semibold">{candidate?.firstName} {candidate?.lastName}</h2>
                    <div className="flex gap-2 text-gray-500">
                        <span className="text-sm">{candidate?.phone}</span>
                    </div>
                </div>
            </div>

            {/* Candidate Stages */}
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <h3 className="text-lg font-semibold border-b border-gray-100 pb-2 mb-5">Candidate Stages</h3>
                <div className="flex justify-between items-center py-3 text-gray-500 border border-gray-100 border-t-4 border-t-blue-500">
                    {["New", "In Review", "Available", "Engaged", "Offered", "Hired", "Rejected"].map(
                        (stage, index) => (
                            <div
                                key={index}
                                className={`flex-1 text-center py-2 cursor-pointer`}
                            >
                                <Radio checked={false}>
                                    {stage}
                                </Radio>
                            </div>
                        )
                    )}
                </div>
            </div>

            {/* Business Card */}
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <Title level={4} className="mb-2">Business Card</Title>
                <div className="text-gray-600">
                    <Form form={form} layout="vertical">
                        <EditableFormBlock
                            config={leadsConfig}
                            id={'676309bc1dfd530a46b512e5'}
                            form={form}
                        />
                    </Form>
                </div>
            </div>
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <h3 className="text-lg font-semibold mb-2 border-b border-gray-100 pb-2 mb-5">Hide Details</h3>
                <div className="text-gray-600">
                    <div className="font-semibold text-md text-gray-900">Basic Info</div>
                    <div className="p-4 bg-white max-w-7xl mx-auto">
                        <div className="grid grid-cols-2 gap-5">
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Full Name</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>Shubham k</Text>
                            </div>
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Mobile Number</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>89898989889</Text>
                            </div>
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Experiance</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>89898989889</Text>
                            </div>
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Mobile Number</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>89898989889</Text>
                            </div>
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Mobile Number</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>89898989889</Text>
                            </div>
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Mobile Number</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>89898989889</Text>
                            </div>
                        </div>
                    </div>
                    <div className="font-semibold text-md text-gray-900">Address Information
                    </div>
                    <div className="font-semibold text-md text-gray-900">Professional Details</div>
                    <div className="font-semibold text-md text-gray-900">Social Links</div>
                    <div className="font-semibold text-md text-gray-900">Other Info</div>
                    <div className="font-semibold text-md text-gray-900">Educational Details</div>
                    <div className="font-semibold text-md text-gray-900">Experience Details</div>
                </div>
            </div>
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <h3 className="text-lg font-semibold mb-2 border-b border-gray-100 pb-2 mb-5">Attachments</h3>
                <div className="text-gray-600">
                    <div className="p-4 bg-white max-w-7xl mx-auto">
                        <div className="grid grid-cols-2 gap-5">
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Full Name</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>Shubham k</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <h3 className="text-lg font-semibold mb-2 border-b border-gray-100 pb-2 mb-5">Interviews</h3>
                <div className="text-gray-600">
                    <div className="p-4 bg-white max-w-7xl mx-auto">
                        <div className="grid grid-cols-2 gap-5">
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Full Name</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>Shubham k</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <h3 className="text-lg font-semibold mb-2 border-b border-gray-100 pb-2 mb-5">Emails</h3>
                <div className="text-gray-600">
                    <div className="p-4 bg-white max-w-7xl mx-auto">
                        <div className="grid grid-cols-2 gap-5">
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Full Name</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>Shubham k</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <h3 className="text-lg font-semibold mb-2 border-b border-gray-100 pb-2 mb-5">Client Submission</h3>
                <div className="text-gray-600">
                    <div className="p-4 bg-white max-w-7xl mx-auto">
                        <div className="grid grid-cols-2 gap-5">
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Full Name</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>Shubham k</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <h3 className="text-lg font-semibold mb-2 border-b border-gray-100 pb-2 mb-5">SMS</h3>
                <div className="text-gray-600">
                    <div className="p-4 bg-white max-w-7xl mx-auto">
                        <div className="grid grid-cols-2 gap-5">
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Full Name</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>Shubham k</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <h3 className="text-lg font-semibold mb-2 border-b border-gray-100 pb-2 mb-5">Invited Events</h3>
                <div className="text-gray-600">
                    <div className="p-4 bg-white max-w-7xl mx-auto">
                        <div className="grid grid-cols-2 gap-5">
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Full Name</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>Shubham k</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <h3 className="text-lg font-semibold mb-2 border-b border-gray-100 pb-2 mb-5">Campaigns</h3>
                <div className="text-gray-600">
                    <div className="p-4 bg-white max-w-7xl mx-auto">
                        <div className="grid grid-cols-2 gap-5">
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Full Name</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>Shubham k</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <h3 className="text-lg font-semibold mb-2 border-b border-gray-100 pb-2 mb-5">Checklists</h3>
                <div className="text-gray-600">
                    <div className="p-4 bg-white max-w-7xl mx-auto">
                        <div className="grid grid-cols-2 gap-5">
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Full Name</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>Shubham k</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <h3 className="text-lg font-semibold mb-2 border-b border-gray-100 pb-2 mb-5">To-Dos</h3>
                <div className="text-gray-600">
                    <div className="p-4 bg-white max-w-7xl mx-auto">
                        <div className="grid grid-cols-2 gap-5">
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Full Name</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>Shubham k</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-6 bg-white p-4 shadow-md rounded-lg">
                <h3 className="text-lg font-semibold mb-2 border-b border-gray-100 pb-2 mb-5">Answered Assessments</h3>
                <div className="text-gray-600">
                    <div className="p-4 bg-white max-w-7xl mx-auto">
                        <div className="grid grid-cols-2 gap-5">
                            <div className="flex flex-cols space-x-6">
                                <p className="font-medium text-gray-700 w-1/4 text-right">Full Name</p>
                                <Text className="text-gray-600 w-3/4 border-b border-gray-100 font-semibold px-2" editable={{
                                    triggerType: ['icon', "text"]
                                }}>Shubham k</Text>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CandidateOverview;
